module.exports = __webpack_public_path__ + "static/logo_hera_mi_rvb-a92e53f3e6af2be95d88225bb1e500cb.svg";